import React, { useState } from 'react';
import { Breadcrumb, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { AnimalTable, CommissionTable } from "../../components/Tables";
import { AnimalFilter, CommissionFilter } from '../../components/Filters';



export default () => {
    const [filter, setFilter] = useState({});
    return (
        <div className="justify-content-between flex-wrap flex-md-nowrap py-4">
            <div className="mb-4 mb-lg-0">
                <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                    <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                    <Breadcrumb.Item>Financeiro</Breadcrumb.Item>
                    <Breadcrumb.Item active>Comissões</Breadcrumb.Item>

                </Breadcrumb>

                <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-4">
                    <Col className="d-block mb-4 mb-md-0">
                        <h1 className="h2">Consulta de Comissões</h1>
                        <p className="mb-0">
                            Tabela contendo todos as comissões cadastrados.
                        </p>
                    </Col>
                </Row>
                {/* <AnimalFilter setFilter={setFilter}/>
                <AnimalTable filter={filter}/>  */}

                <CommissionFilter setFilter={setFilter}/>
                <CommissionTable filter={filter}/>
            </div>
        </div >
    );
};
